
export default {
  name: 'AppExpandIcon'
};
